import useSWR from 'swr'

import { FetchError } from '../../../data/fetchError'
import { FetchResponse } from '../../../data/fetchResponse'
import { FetchResult } from '../../../data/fetchResult'
import { fetchJson } from '../../../data/fetchers'
import { EInvoiceDto } from '../../../data/models'
import { InvoiceLineType } from '../../../data/models/_generatedUblInvoice'
import { useConfigContext } from '../../ui-config'

// Get all e-invoice lines
export function useAllEInvoiceLines(
  eInvoiceId?: string | null,
): FetchResult<InvoiceLineType[]> {
  const url = eInvoiceId ? `/einvoices/${eInvoiceId}/lines` : null

  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<InvoiceLineType[]>,
    FetchError
  >(url, fetchJson<InvoiceLineType[]>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

// Get e-invoice line
export function useEInvoiceLineById(
  eInvoiceId?: string | null,
  lineId?: string | null,
): FetchResult<InvoiceLineType> {
  const url = eInvoiceId ? `/einvoices/${eInvoiceId}/lines/${lineId}` : null

  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<InvoiceLineType>,
    FetchError
  >(url, fetchJson<InvoiceLineType>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

// Get all e-invoices
export function useAllEInvoices(): FetchResult<EInvoiceDto[]> {
  const { pollingConfig } = useConfigContext()
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<EInvoiceDto[]>,
    FetchError
  >('/einvoices', fetchJson<EInvoiceDto[]>, {
    refreshInterval: pollingConfig.intervalInSeconds * 1000,
  })

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

// Get e-invoice by ID
export function useEInvoiceById(
  eInvoiceId?: string | null,
): FetchResult<EInvoiceDto> {
  const url =
    !eInvoiceId || eInvoiceId === 'errors' ? null : `/einvoices/${eInvoiceId}`
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<EInvoiceDto>,
    FetchError
  >(url, fetchJson<EInvoiceDto>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}
